import { AddTrialNotificationTemplate } from "./add-trial-notification-template.model";

export class UpdateTrialNotificationTemplate extends AddTrialNotificationTemplate {
  public id: string;

  constructor(init?: Partial<UpdateTrialNotificationTemplate>) {
    super(init);

    Object.assign(this, init);
  }
}
